<template>
<component
  :is="domNode"
  v-if="canSee"
  :class="['sidebar-item', {
    'sidebar-item_active': activeLink,
    'sidebar-item_disabled': isDisabled,
    'sidebar-item_ellipsis': textEllipsis,
    'sidebar-item_lv-1': icon
  }]"
  :to="to"
  :href="href || undefined"
  :target="target"
  :exact="to ? true : false"
  @click="handleClick"
>
  <span class="sidebar-item__icon">
    <KonturIcon v-if="icon" size="24" :name="icon" />
  </span>
  <span :class="['sidebar-item__title', {'sidebar-item__title_ellipsis': textEllipsis}]">
    <slot></slot>
  </span>
  <vs-chip v-if="tag" class="sidebar-item__tag">{{ tag }}</vs-chip>
</component>
</template>

<script>
import KonturIcon from '@/components/KonturIcon'

export default {
  name: 'SidebarItem',
  components: {
    KonturIcon
  },
  props: {
    icon: {
      type: String
    },
    href: {
      type: String
    },
    to: {
      type: String
    },
    target: {
      default: '_self',
      type: String
    },
    isDisabled: {
      default: false,
      type: Boolean
    },
    tag: {
      type: String
    },
    textEllipsis: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      activeLink: false
    }
  },
  watch: {
    '$route'() {
      this.checkIsActive()
    }
  },
  methods: {
    checkIsActive() {
      if (this.to) {
        if (this.$route.path.slice(1).includes(this.to.slice(1)) && this.to.slice(1)) this.activeLink = true
        else this.activeLink = false
      }
    },
    handleClick(e) {
      /**
         * Click event
         *
         * @event click
         */
      this.$emit('click', e)
    }
  },
  computed: {
    canSee() {
      this.$acl.check(this.$store.state.userRole)
      if (this.to) {
        return this.$acl.check(this.$router.match(this.to).meta.rule)
      }
      return true
    },
    domNode() {
      if (this.to) {
        return 'router-link'
      }
      if (this.href) {
        return 'a'
      }
      if (this.$listeners.click) {
        return 'button'
      }
      return 'span'
    }
  },
  updated() {
    this.checkIsActive()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuesax/_variables.scss';

.sidebar-item {
  padding: 0 $size-1;
  margin: 0;
  list-style-type: none;
  display: flex;
  min-height: $size-5;
  align-items: center;
  width: 100%;
  border: 0;
  background-color: transparent;
  border-radius: $size-1;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.48);
  }

  &_active,
  &[aria-current="page"] {
    background-color: $white;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px inset rgb(28, 126, 223);
    background-color: $white;
    outline: none;
  }

  &_disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  &_lv-1 {
    min-height: 48px;
  }

  &__icon {
    width: $size-3;
    height: $size-3;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: $size-1 + $size-half;
  }

  &__title {
    text-align: left;

    &_ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      min-width: 0;
      flex: 1;
    }
  }
}
</style>
